import React from "react";
import PropTypes from "prop-types";

import Form from "./steps/Form";
import Choice from "./steps/Choice";
import Message from "./steps/Message";
import ImageChoice from "./steps/ImageChoice";
import { StepShape } from "./utils/types";

const COMPONENTS = {
  submit: Form,
  choice: Choice,
  message: Message,
  imageChoice: ImageChoice,
};

const UnsupportedStep = (props) => (
  <h1 style={{ margin: "45vh auto", textAlign: "center" }}>
    Unsupported step of type {props.type}
  </h1>
);

const Step = (props) => {
  const Component = COMPONENTS[props.type] || UnsupportedStep;

  return <Component {...props} key={props.id} />;
};

export default function FormJourney({
  step,
  onStepChange,
  styleElement,
  variables,
  emptyVariableFormatter = null,
  previewMode = false,
}) {
  return (
    <Step
      {...step}
      onSubmit={handleSubmit}
      styleElement={styleElement}
      variables={variables}
      emptyVariableFormatter={emptyVariableFormatter}
      previewMode={previewMode}
    />
  );

  function handleSubmit(value, id) {
    onStepChange(value, id);
  }
}

FormJourney.propTypes = {
  onStepChange: PropTypes.func.isRequired,
  step: StepShape.isRequired,
  styleElement: PropTypes.object,
  variables: PropTypes.object,
  emptyVariableFormatter: PropTypes.func,
  previewMode: PropTypes.bool,
};

UnsupportedStep.propTypes = {
  type: PropTypes.string.isRequired,
};

Step.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
